
import React from "react";

interface HomeProps {
  onNavigate: (view: 'cake-run' | 'character-creator' | 'axolotl-driving-game' | 'axolotl-clickr' | 'axolotl-painter' | 'axolotl-baseball' | 'axolotl-disco' | 'axolotl-flips' | 'axolotl-lippies') => void;
}

const Home: React.FC<HomeProps> = ({ onNavigate }) => {
  return (
    <div>
      <style>{`
        body, .axolotl-home-root {
            margin: 0;
            padding: 0;
            font-family: Arial, sans-serif;
            background-color: #f0f0f0;
        }
        .container {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: row;
            min-height: 20vh;
            background-color: #ff69b4;
            color: white;
            text-align: center;
            padding: 2rem;
        }
        h1 {
            margin: 0 0 1rem 0;
            font-size: 3rem;
        }
        h2 {
            margin: 0;
            font-size: 1.5rem;
            font-weight: normal;
        }
        .game-menu-wrapper {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            margin-top: 2rem;
            gap: 2rem;
            flex-wrap: wrap;
        }
        .game-link-wrapper {
            display: flex;
            justify-content: center;
            margin-top: 2rem;
        }
        .game-link {
            text-decoration: none;
            color: inherit;
        }
        .game-preview-img {
            width: 400px;
            max-width: 90vw;
            border-radius: 16px;
            box-shadow: 0 6px 24px rgba(0,0,0,0.15);
            transition: transform 0.2s;
        }
        .game-title {
            text-align: center;
            margin-top: 0.5rem;
            font-size: 1.2rem;
            font-weight: bold;
        }
      `}</style>
      <div className="axolotl-home-root">
        <div className="container">
          <img
            src="/img/axolotlrainbow.png"
            alt="Axolotl Rainbow"
            style={{ height: "120px", marginRight: "2rem" }}
          />
          <div>
            <h1>Axolotl Games</h1>
            <h2>Come play some games about all kinds of stuff.</h2>
            <p>
              <a href="https://www.youtube.com/watch?v=dQw4w9WgXcQ">Click me</a>
            </p>
          </div>
          <img
            src="/img/axolotlrainbow.png"
            alt="Axolotl Rainbow"
            style={{ height: "120px", marginLeft: "2rem" }}
          />
        </div>
        <div className="game-menu-wrapper">
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('cake-run')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/game_preview.jpg"
              alt="Axolotl Cake Run Preview"
              className="game-preview-img"
            />
            <div className="game-title">
              Play Axolotl Cake Run
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('character-creator')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/character_creator_preview.png"
              alt="Axolotl Character Creator Preview"
              className="game-preview-img"
            />
            <div className="game-title">
              Axolotl Character Creator
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('axolotl-driving-game')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/axolotl_driving.png"
              alt="Axolotl Driving Game Preview"
              className="game-preview-img"
            />
            <div className="game-title">
              Axolotl Driving Game
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('axolotl-clickr')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/axolotl_clicker.png"
              alt="Axolotl Clickr Preview"
              className="game-preview-img"
            />
            <div className="game-title">
              Axolotl Clickr
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('axolotl-painter')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/axolotl_painter.png"
              alt="Axolotl Painter Preview"
              className="game-preview-img"
            />
            <div className="game-title">
              Axolotl Painter
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('axolotl-baseball')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/axolotlbaseball.png"
              alt="Axolotl Baseball"
              className="game-preview-img"
            />
            <div className="game-title">
              Axolotl Baseball
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('axolotl-disco')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/axolotldisco.png"
              alt="Axolotl Disco"
              className="game-preview-img"
            />
            <div className="game-title">
              Axolotl Disco
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('axolotl-flips')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/axolotl_flips.jpg"
              alt="Axolotl Flips"
              className="game-preview-img"
            />
            <div className="game-title">
              Axolotl Flips
            </div>
          </button>
        </div>
        <div className="game-link-wrapper">
          <button
            onClick={() => onNavigate('axolotl-lippies')}
            className="game-link"
            style={{ background: 'none', border: 'none', cursor: 'pointer', padding: 0 }}
          >
            <img
              src="/img/axolotl_lippies.jpg"
              alt="Lippies"
              className="game-preview-img"
            />
            <div className="game-title">
              Lippies
            </div>
          </button>
        </div>
        </div>
      </div>
    </div>
  );
};

export default Home;